var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentLearning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.44,128.23V84.5A13.67,13.67,0,0,0,133.8,70.87H120.17A13.67,13.67,0,0,0,106.53,84.5v43.73Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 126.99,
    cy: 45.91,
    r: 13.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.82,128.23V84.5a13.67,13.67,0,0,0-13.63-13.63H175.55A13.67,13.67,0,0,0,161.92,84.5v43.73Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 182.37,
    cy: 45.91,
    r: 13.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.62,90.25v77.88s30.47-12.93,57.87,4.61V94.25S48,74.24,16.62,90.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.67,128.87v39.26S102.2,155.2,74.8,172.74V94.25a58.87,58.87,0,0,1,31.54-10.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.62,180.44s30.47-12.93,57.87,4.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.67,180.44s-30.47-12.93-57.87,4.62"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentLearning);
export default __webpack_public_path__ + "static/media/STUDENT_LEARNING.26b05a3335aefb9b0a642ec42124de14.svg";
export { ForwardRef as ReactComponent };